const bubbleSvg = d3.create('svg');
bubbleSvg.attr('viewBox', '0 0 125 125');
bubbleSvg.attr('fill', 'none');
bubbleSvg.attr('stroke-width', '6');
bubbleSvg.append('path')
    .attr('d', `M 125 125
                L 62.5 125
                A 62.5 62.5 0 1 1 125 62.5
                L 125 125
                L 62.5 125`);
const svgBubbles = {};
function svgBubble(colour) {
    if (!svgBubbles[colour]) {
        svgBubbles[colour] = bubbleSvg.node().cloneNode(true);
    }
    return svgBubbles[colour];
}

export function createChart(
    { primaryMetric, colour },
    options
) {
    return {
        // position: 'col-2',
        // y: 'h-8',
        font: { colour },
        mb: 12,
        bubble: {
            h: 'w-1',
            w: 'w-1',
            styles: { stroke: colour },
            svg: svgBubble(colour),
            val: {
                y: 25,
                align: 'center',
                text: `${primaryMetric.formatWithUnits(primaryMetric.value)}`,
                font: { weight: 'bold', size: 'xl' },
            }
        },
        label: {
            display: 'inline',
            font: { style: 'italic' },
            x: 'w-0-1/4',
            w: 'w-2-3/4',
            y: 20,
            text: `of people ${primaryMetric.valueLabel ? `in ${primaryMetric.valueLabelFull}` : ''} ${primaryMetric.label}`
        },
        ...options
    };
}

export default ({ primaryBeliefMetricModel: primaryMetric, colorClass: colour }, options) => {
    if (primaryMetric && primaryMetric.value) {
        return createChart({ primaryMetric, colour }, options);
    }
    return null;
};
